import axios from "axios";

export const getSimulatorTasks = async (repoId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SIMULATOR}/sessions/detail?user_id=${repoId}`);
        return response.data;
    } catch (error) {
        console.log(error)
    }
};

export const getSimulatorUsers = async (companyId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SIMULATOR}/users/?company_id=${companyId}`);
        return response.data;
    } catch (error) {
        console.log(error)
    }
};

export const getSimulators = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SIMULATOR}/simulators/with-sessions`);
        return response.data;
    } catch (error) {
        console.log(error)
    }
}

export const getSituations = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SIMULATOR}/situations/`);
        return response.data;
    } catch (error) {
        console.log(error)
    }
};

export const getProfiles = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SIMULATOR}/profiles/`);
        return response.data;
    } catch (error) {
        console.log(error)
    }
};

export const postAssignSimulation = async (payload) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SIMULATOR}/simulators/assign-bulk`, payload);
        return response.data;
    } catch (error) {
        console.log(error)
    }
};

export const getSimulatorAnalytics = async (simulatorId, runCode) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SIMULATOR}/analysis/?simulator_id=${simulatorId}&run_code=${runCode}`);
        return response.data;
    } catch (error) {
        console.log(error)
    }
};

export const getSimulatorPDF = async (simulatorId, runCode) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SIMULATOR}/reports/performance-summary/pdf?simulator_id=${simulatorId}&run_code=${runCode}`, {
            responseType: 'blob'
        });
        return response.data;
    } catch (error) {
        console.log(error)
    }
};
